import axios from "../../services/axiosConfig";

const applicationService = {
  /**
   * Fetch applications submitted by the authenticated influencer
   */
  getMyApplications: async () => {
    try {
      const response = await axios.get("/company/campaigns/applications/me");
      // Normalise possible shapes
      if (response?.data?.data) return response.data.data;
      if (Array.isArray(response?.data)) return response.data;
      return [];
    } catch (error) {
      console.error("Error fetching influencer applications:", error);
      throw new Error(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch your applications"
      );
    }
  },
};

export default applicationService;
